/**
 * Redacted error logging — status + message only, never the full error object.
 * HTTP-layer errors carry the complete response body and request config
 * (potentially student PII); `console.error` is never suppressed in production
 * (src/index.tsx only silences log/warn) and is forwarded to the mac-app
 * native log bridge. User-facing feedback is the notification/toast's job —
 * this exists purely as a debugging breadcrumb.
 */
export const logRedactedError = (context: string, error: unknown): void => {
  const err = error as { statusCode?: unknown; status?: unknown; message?: unknown } | null;
  const status = err?.statusCode ?? err?.status;
  const message = typeof err?.message === 'string' ? err.message : String(error);
  console.error(`${context}${typeof status === 'number' ? ` [${status}]` : ''}: ${message}`);
};
